import {TabIconVariant} from 'platform/components';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getSafely} from 'shared/web';

import type {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';

type LocalizedContent = GeneralSettingsFormValues['localizedContent'];

export function getLanguageIcon(
  localizedContent: LocalizedContent,
  languageCode: string
): TabIconVariant {
  const entry = getSafely(localizedContent, languageCode);
  const hasFill =
    isNotNilOrEmpty(entry?.titleExtension) ||
    isNotNilOrEmpty(entry?.subtitle) ||
    isNotNilOrEmpty(entry?.description);
  return hasFill ? 'success' : 'default';
}
